import { useState, useEffect, useCallback } from 'react';
import * as Yup from 'yup';
import toast from 'react-hot-toast';
import { getInfo, saveInfo } from 'src/services/CacheStorage';

// Yup validation schema for email
const emailSchema = Yup.string()
  .email('Invalid email address')
  .required('Email is required');

// Email controller logic
export const useEmailController = (initialEmail, t, apiChangeEmail) => {
  const [isEditing, setIsEditing] = useState(false);
  const [formEmail, setFormEmail] = useState(initialEmail);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    // Set formEmail with the initial value from the email prop when the component mounts
    setFormEmail(initialEmail);
  }, [initialEmail]);

  const validateEmail = async (emailToValidate) => {
    try {
      await emailSchema.validate(emailToValidate); // Yup validation
      setIsError(false); // Clear error if valid
      setErrorMessage('');
      return true; // Email is valid
    } catch (err) {
      setIsError(true); // Set error state
      setErrorMessage(err.message); // Set error message from Yup
      return false; // Email is invalid
    }
  };

  const newEmailChange = (event) => {
    const newEmail = event.target.value;
    setFormEmail(newEmail);

    // Validate email as it changes
    validateEmail(newEmail);
  };

  const handleEdit = useCallback(async () => {
    if (isEditing) {
      // Try to submit the email when exiting edit mode
      const isValid = await validateEmail(formEmail);
      if (isValid) {
        try {
          await apiChangeEmail(formEmail, t); // Call API to change email
          // toast.success('Email changed successfully!');
          // Get and refresh email
          const user = getInfo();
          user.email = formEmail;
          await saveInfo(user);
        } catch (error) {
          toast.error(t('OOPS')); // Handle API error
        }
      } else {
        toast.error(errorMessage); // Display validation error if invalid
      }
    }
    setIsEditing((prevState) => !prevState); // Toggle edit mode
  }, [isEditing, formEmail, apiChangeEmail, t, errorMessage]);

  return {
    isEditing,
    formEmail,
    isError,
    errorMessage,
    setIsEditing,
    newEmailChange,
    handleEdit,
  };
};
